/** @format */

/**
 * Global client side database powered by localStorage
 *
 * Uses memory localStorage instead of indexedDB for browser compatibility.
 *
 * DO NOT STORE PRIVATE OR SENSITIVE INFORMATION!!!!! NON-SECURE
 * This client side db is for client side caching of commonly used
 * data elements that are considered non-secure. Examples include:
 *  Facility names
 *  District names
 *  Reference type data
 *
 * Data relating to individuals should never be stored here.
 *
 * To Store Data:
 * app.db.put = function put(key, val, expires_minutes = DEFAULT_EXPIRES_MINUTES)
 *      example: app.db.put('mykey', {id:0}, 500);
 *
 * app.db.get = function get(key)
 *      example: app.db.get('mykey');
 *
 * Commonly used ajax data which is cached in localStorage and Memory. The first call
 * to one of these will get from server via ajax, any subsequent calls before a page
 * refresh will retreive from memory. After a page refresh localStorage will be
 * used to fetch and again stored in memory until the next page refresh, etc. Once
 * the 'expires_minutes' value is less then the current time ajax will be used
 * to reload the data from the server.
 *
 * app.db.getFacilities(function(data){  //data = array of facilites  });
 * app.db.getCommunities(function(data){  //data = array of communities  });
 *
 * */

// extend the app var
var app = window.app || {};
(function(window, $) {
    var app = window.app || {};
    var NAMESPACE = "ecsp_";
    var EXPIRATION_KEY = "_expiration";
    var FACILITIES_KEY = "facilities";
    var COMMUNITIES_KEY = "communities";
    var ROLES_KEY = "roles";
    var DEFAULT_EXPIRES_MINUTES = 60 * 2; // 2 hours

    // quicky pollyfill for localstorage
    if (!window.localStorage) {
        window.localPolyfill = {};
        window.localStorage.getItem = function(key) {
            return window.localPolyfill[key];
        };
        window.localStorage.setItem = function(key, value) {
            window.localPolyfill[key] = value;
        };
    }
    app.db = app.db;
    app.db.facilities = [];
    app.db.hasFacilites = false;
    app.db.communities = [];
    app.db.hasCommunities = false;
    app.db.tmp = {}; // temp storage not persisted
    app.db.user = {
        username: null,
        roles: {}
    };

    app.db.isExpired = function isExpired(key) {
        window.debug("check expiration for " + key + EXPIRATION_KEY);
        var expires = app.db._rawFetch(key + EXPIRATION_KEY);
        window.debug(expires);
        if (expires) {
            var d = moment.unix(JSON.parse(expires).data);
            // if expiration is les than now, expired = true
            return d.isBefore(moment().now);
        } else {
            return true;
        }
    };

    /**
     * internal use, don't use
     * @param {any} key key
     * @returns {any} object/value or null if not present
     */
    app.db._rawFetch = function _rawFetch(key) {
        return window.localStorage.getItem(NAMESPACE + key);
    };

    /**
     * Get an object or value from local storage. returns null if not present or expired
     * @param {any} key Key to fetch
     * @returns {any} object/value or null if not present or expired
     */
    app.db.get = function get(key) {
        if (app.db.isExpired(key)) {
            window.debug(key + " is expired");
            localStorage.removeItem(NAMESPACE + key);
            return null;
        }
        var val = app.db._rawFetch(key);
        if (!val) return null;
        var jval = JSON.parse(val);
        return jval.data; // internally store in json object
    };

    /**
     * Put an object or value into local storage
     * @param {any} key the key to store under
     * @param {any} val the value to store
     * @param {any} expires_minutes optional expiration time in minutes
     */
    app.db.put = function put(key, val, expires_minutes) {
        if (expires_minutes === undefined) {
            expires_minutes = DEFAULT_EXPIRES_MINUTES;
        }

        var expires = moment()
            .add(expires_minutes, "m")
            .valueOf();
        var sdata = JSON.stringify({ data: val });
        window.localStorage.setItem(NAMESPACE + key, sdata);
        var tdata = JSON.stringify({ data: expires });
        window.localStorage.setItem(NAMESPACE + key + EXPIRATION_KEY, tdata);
    };

    /**
     * Get a list of Facilities, possibly cached in memory or localStorage. Fetches from server otherwise.
     * @param {any} _callback A function to be called and passed the array of Facilites
     */
    app.db.getFacilities = function getFacilities(_callback) {
        // if already loaded into memory, use that
        if (app.db.hasFacilites) {
            if (_callback) {
                _callback(app.db.facilities);
            }
        }
        var cached = window.app.db.get(FACILITIES_KEY);
        if (cached) {
            if (_callback) {
                // cache in memory
                app.db.facilities = cached;
                app.db.hasFacilites = true;

                // return data
                _callback(cached);
            }
        } else {
            $.get(
                window.app.hrefPrefix() +
                    "/" +
                    window.app.currentLanguage() +
                    "/data/GetFacilities?ver=" +
                    window.app.version,
                function(data) {
                    // transform into select2 native format
                    data = $.map(data, function(e, i) {
                        return { id: e.Id, text: e.Title, point: e.Point };
                    });

                    // cache in localStorage
                    window.app.db.put(FACILITIES_KEY, data);

                    // cache in memory
                    app.db.facilities = data;
                    app.db.hasFacilites = true;

                    // return via callback
                    if (_callback) {
                        _callback(data);
                    }
                }
            );
        }
    };

    /**
     * Get a list of Communities, possibly cached in memory or localStorage. Fetches from server otherwise.
     * @param {any} _callback A function to be called and passed the array of Communities
     */
    app.db.getCommunities = function getCommunities(_callback) {
        // if already loaded into memory, use that
        if (app.db.hasCommunities) {
            if (_callback) {
                _callback(app.db.communities);
            }
        }

        var cached = window.app.db.get(COMMUNITIES_KEY);
        if (cached) {
            if (_callback) {
                // cache in memory
                app.db.communities = cached;
                app.db.hasCommunities = true;

                // return data
                _callback(cached);
            }
        } else {
            $.get(
                window.app.hrefPrefix() +
                    "/" +
                    window.app.currentLanguage() +
                    "/data/GetCommunities?ver=" +
                    window.app.version,
                function(data) {
                    // transform into select2 native format
                    data = $.map(data, function(e, i) {
                        return { id: i + 1, text: e.Name };
                    });

                    // cache in localStorage
                    window.app.db.put(COMMUNITIES_KEY, data);

                    // cache in memory
                    app.db.communities = data;
                    app.db.hasCommunities = true;

                    if (_callback) {
                        _callback(data);
                    }
                }
            );
        }
    };

    /**
     * Print the current size of localStorage to the console
     * */
    app.db.getDbSize = function printDbSize() {
        /**
         * Size can also be determined by the expression:
         * console.log(new Blob(Object.values(localStorage)).size/1024*2);
         *
         * but Blob isn't supported on most mobile browsers
         * */
        var _lsTotal = 0,
            _xLen,
            _x;
        for (_x in localStorage) {
            if (!localStorage.hasOwnProperty(_x)) {
                continue;
            }
            _xLen = (localStorage[_x].length + _x.length) * 2; // js uses utf16, so 4 bytes not two, need to double the count
            _lsTotal += _xLen;
            debug(_x.substr(0, 50) + " = " + (_xLen / 1024).toFixed(2) + " KB");
        }
        debug("Total = " + (_lsTotal / 1024).toFixed(2) + " KB");
    };
})(window, jQuery);
